import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { H1, color } from '@ticketswap/solar'
import Link from 'next/link'
import { getLinkProps } from '~/utils'
import { decodeGlobalId } from '~/utils/id'

const StyledLink = styled.a`
  h1 {
    color: ${color.nova};

    [data-theme='dark'] & {
      color: ${color.space};
    }
  }
`

const EventTitle = ({ eventId, eventName, eventSlug }) => (
  <Link
    {...getLinkProps('EVENT_PAGE', {
      eventSlug,
      eventId: decodeGlobalId(eventId),
    })}
    passHref
  >
    <StyledLink>
      <H1>{eventName}</H1>
    </StyledLink>
  </Link>
)

EventTitle.propTypes = {
  eventId: PropTypes.string,
  eventName: PropTypes.string,
  eventSlug: PropTypes.string,
}

export default EventTitle
